import StockUpdate from './StockUpdate'
export {StockUpdate}
export default StockUpdate
